export const transformCategoriesToChartData = (
  statistics: { name: string; caseCount: number }[],
  t: (key: string) => string,
) => {
  return statistics.map((statistic) => ({
    id: t(statistic.name || "delegation"),
    label: t(statistic.name || "delegation"),
    value: (
      (statistic.caseCount * 100) /
      statistics.map((item) => item.caseCount).reduce((a, b) => a + b)
    ).toFixed(2),
  }));
};
